import { Card, Skeleton, Stack, Box, Grid } from '@mui/material';

export function StatCardSkeleton({ count = 4 }) {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: count }, (_, i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <Card sx={{ p: 3 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Box>
                <Skeleton variant="text" width={60} height={40} />
                <Skeleton variant="text" width={100} height={20} />
              </Box>
              <Skeleton variant="rounded" width={56} height={56} sx={{ borderRadius: 2 }} />
            </Stack>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export function DetailCardSkeleton() {
  return (
    <Card sx={{ p: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Skeleton variant="text" width={200} height={32} />
        <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: 1 }} />
      </Stack>
      <Skeleton variant="text" width="100%" sx={{ mb: 1 }} />
      <Grid container spacing={2}>
        {Array.from({ length: 6 }, (_, i) => (
          <Grid item xs={6} key={i}>
            <Skeleton variant="text" width={80} height={16} />
            <Skeleton variant="text" width={140} height={24} />
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}

export function ListCardSkeleton({ count = 3 }) {
  return (
    <Stack spacing={2}>
      {Array.from({ length: count }, (_, i) => (
        <Card key={i} sx={{ p: 3 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box sx={{ flex: 1 }}>
              <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                <Skeleton variant="text" width={160} height={28} />
                <Skeleton variant="rounded" width={70} height={22} sx={{ borderRadius: 1 }} />
              </Stack>
              <Stack direction="row" spacing={3}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={100} />
              </Stack>
            </Box>
            <Stack direction="row" spacing={2} alignItems="center">
              <Skeleton variant="text" width={70} height={28} />
              <Skeleton variant="text" width={60} height={28} />
            </Stack>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}

export function CategoryCardSkeleton({ count = 4 }) {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: count }, (_, i) => (
        <Grid item xs={12} sm={6} key={i}>
          <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Skeleton variant="rectangular" height={160} />
            <Box sx={{ p: 2 }}>
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Skeleton variant="text" width={140} height={28} />
                <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: 1 }} />
              </Stack>
              <Skeleton variant="text" width="100%" />
              <Skeleton variant="text" width="60%" sx={{ mb: 1.5 }} />
              <Stack direction="row" justifyContent="space-between">
                <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: 1 }} />
                <Skeleton variant="text" width={60} height={24} />
              </Stack>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export function FormSkeleton() {
  return (
    <Card sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Skeleton variant="text" width={200} height={32} />
        {Array.from({ length: 4 }, (_, i) => (
          <Box key={i}>
            <Skeleton variant="text" width={120} height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="rounded" height={56} sx={{ borderRadius: 1.5 }} />
          </Box>
        ))}
        <Skeleton variant="rounded" width={160} height={42} sx={{ borderRadius: 1.5, mt: 1 }} />
      </Stack>
    </Card>
  );
}
